<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="solution">
        <div class="breadCrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>新闻中心</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="news_3">   
          <div class="picImg"><a href="#/newsCenter/goodNews"><img src="../../../public/newsImg/news_goodNews.png" alt=""></a></div>
          <div class="content">
            <div class="title"><p><a href="#/newsCenter/goodNews">喜讯 | 中标喜讯</a></p></div>
            <span></span>
            <a href="#/newsCenter/goodNews"><p>热烈祝贺我司凭借丰富的实施经验、过硬的技术实力和良好的企业信誉，于2021年4月8日顺利中标——中国光大银行信用卡科技敏捷体系建设实施服务采购项目（招标编号：TC210902A）...</p></a>
            <div class="dianji"><a href="#/newsCenter/goodNews" target="_blank">查看详情 </a> </div>
          </div>
         <div class="data">
            <div class="year">2021</div>
            <span></span>
            <p>04.08</p>
          </div>
        </div>  
        <div class="news_1">   
          <div class="picImg"><a href="#/newsCenter/activity"><img src="../../../public/newsImg/news_activity.png" alt=""></a></div>
          <div class="content">
            <div class="title"><p><a href="#/newsCenter/activity">活动丨功存智能携手老麦咖啡亮相2020敏捷之旅上海站</a></p></div>
            <span></span>
            <a href="#/newsCenter/activity"><p>2020是极其特殊的一年，深刻诠释了VUCA年代的意义，这也促使我们更加深入的思考，作为个体、团队、组织、如何面对世界的不确定性，如何更好的应对世界的复杂多变...</p></a>
            <div class="dianji"><a href="#/newsCenter/activity" target="_blank">查看详情 </a> </div>
          </div>
         <div class="data">
            <div class="year">2020</div>
            <span></span>
            <p>12.13</p>
          </div>
        </div>  
        <div class="news_2">
          <div class="picImg"><a href="#/newsCenter/honor"><img src="../../../public/newsImg/news_honor.png" alt=""></a></div>
          <div class="content">
            <div class="title"><p><a href="#/newsCenter/honor">荣誉丨功存智能获得CMMI三级证书</a></p></div>
            <span></span>
            <a href="#/newsCenter/honor"><p>2020年8月31日，在上海功存智能科技有限公司会议室举行的CMMI3级认证结果发布会上，评估师宋骏老师向公司高层及参与评审的项目组成员郑重宣布：经过严格的现场审核和评估，上海功存智能......</p></a>
            <div class="dianji"><a href="#/newsCenter/honor" target="_blank">查看详情 </a> </div>
          </div>
          <div class="data">
            <div class="year">2020</div>
            <span></span>
            <p>08.31</p>
          </div>
        </div>
      </div>    
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'新闻中心',
          detail:'News center',
          src: require("../../../public/newsImg/newsbanner.png"),
        },
      ]
    }
  },
  mounted(){
    // console.log(this.$route)
  }
}
</script>
<style lang="scss" scoped>

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 20px;
          // width: 326px;
        }
      }
    }
  }


.solution{
  height:1327px;
  .breadCrumb{
    height: 67px;
    border-bottom: 1px solid rgba(51, 51, 51, 0.15);
  }
  .picImg{
    width: 400px;
    height: 260px;
    position: relative;
    background: #F8F9FB;
    margin-top: 90px;
    img{
     position: absolute;
     top:50%;
     left: 50%;
     transform: translate(-50%,-50%);
    }
  }

  .content{
    float: left;
    width: 590px;
    margin-left: 430px;
    text-align: left;
    margin-top: -280px;
    span{
      width: 32px;
      height: 2px;
      background: #999;
      display: inline-block;
    }
    p{
      font-size: 16px;
      color: #999;
      line-height: 32px;
    }
    p:hover{
        color: #333;
      }
    .title{
      height: 33px;
      margin-bottom: 10px;
      a{
        font-size: 24px;
        font-weight: bold;
        color: #333;
      }
      a:hover{
        color: #1E8DD4;
      }
      
    }
    .dianji{
      background: url(../../../public/newsImg/jiao3.png) 68px 10px no-repeat ;
      a{
        font-size: 16px;
        color:#333;
      }
    }
    .dianji:hover{
      a{color: #1E8DD4;}
    }
  }
  .data{
    float: right;
    margin-top:-260px;
    text-align: left;
    margin-right: 40px;
    .year{
      font-size: 40px;
      font-weight: bold;
    }
    p{
      font-size: 24px;
      font-weight: 800;
    }
    span{
      width: 32px;
      height: 2px;
      background: #999;
      display: inline-block;
    }
  }
  .news_3{
    height: 319px;
    width: 1200px;
    margin: 0 auto;
    border-bottom: 1px solid rgba(51, 51, 51, 0.15);
  }
  .news_1{
    height: 319px;
    width: 1200px;
    margin: 0 auto;
    border-bottom: 1px solid rgba(51, 51, 51, 0.15);
    .picImg{
      margin-top: 60px;
    }
  }
  .news_2{
    height: 319px;
    width: 1200px;
    margin: 0 auto;
    border-bottom: 1px solid rgba(51, 51, 51, 0.15);
    
    .picImg{
      margin-top: 60px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/newsCenter/newsCenter.vue